








import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import BlurredTenant from '@/components/BlurredTenant.vue';
import moment from 'moment'
// vouchers example:
/**
 * {
  "_id": "67fd162dbbbe0f47952389d6",
  "status": "active",
  "amount": 100000,
  "endTime": 1744898723208,
  "startTime": 1744643109543,
  "code": "evpay-sz516mqm",
  "tenantId": "6612b1c351bb8e4b1d523572",
  "lastUpdatedByUserId": "",
  "createdByUserId": "",
  "updatedTime": 1744639533835,
  "createdTime": 1744639533830,
  "__v": 0,
  "createdByUser": null,
  "tenant": {
    "_id": "6612b1c351bb8e4b1d523572",
    "name": "test02",
    "subdomain": "test02",
    "email": "admin@test02.com",
    "createdTime": 1712501187623,
    "updatedTime": 1733279662939,
    "__v": 0,
    "setting": {
      "exchangeRatioFromCurrency": "vnd",
      "chargingSessionMinPoint": 1000,
      "chargingSessionPointPerKwh": 5000,
      "tax": 8,
      "exchangeRatioFromAmount": 1,
      "exchangeRatioToPointAmount": 1,
      "id": null
    },
    "crossPayment": true,
    "id": "6612b1c351bb8e4b1d523572"
  },
  "lastUpdatedByUser": null,
  "usedByUser": null,
  "id": "67fd162dbbbe0f47952389d6"
}
 */
export default Vue.extend({
    components: { BlurredTenant },
    data() {
        return {
            showBlur: userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) && !!userManager.getUserInfo().tenant?.setting?.expDate && userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
            tableOptions: {
                attrs: {
                    "item-key": "_id",
                    "sort-by": "createdTime",
                    "sort-desc": true,
                },
                content: {
                    name: "Vouchers",
                    search: {
                        ext: {
                            hidden: true,
                        },
                    },
                    filters: {
                        filters: {
                            code: {
                                type: "text",
                                attrs: {
                                    label: "Voucher Code",
                                },
                                rules: {
                                    equal_to: {},
                                },
                            },
                            serialNumber: {
                                type: "text",
                                attrs: {
                                    label: "Serial Number",
                                },
                                rules: {
                                    match: {},
                                },
                            },
                            ...(userManager.checkRole(["systemAdmin", "admin"]) && {
                                tenantId: {
                                    type: "XAutocomplete",
                                    attrs: {
                                        label: "Organization",
                                        required: true,
                                        "item-value": "_id",
                                        "item-text": "name",
                                        xOptions: {
                                            content: {
                                                async itemsSuggestor(search, value, limit) {
                                                    const { items } = await coreApiClient.call("tenants", "findAll", {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters: [
                                                                {
                                                                    key: "_id",
                                                                    operator: "equal_to",
                                                                    value,
                                                                },
                                                            ],
                                                        }),
                                                    });
                                                    return items;
                                                },
                                            },
                                        },
                                    },
                                    rules: {
                                        equal_to: {},
                                    },
                                },
                            }),
                            ...(userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
                                usedByUserId: {
                                    type: "XAutocomplete",
                                    attrs: {
                                        label: "Used by user",
                                        required: true,
                                        "item-value": "_id",
                                        "item-text": "email",
                                        xOptions: {
                                            content: {
                                                async itemsSuggestor(search, value, limit) {
                                                    const { items } = await coreApiClient.call("users", "findAllUser", {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "email",
                                                            orderType: "asc",
                                                            filters: [
                                                                {
                                                                    key: "_id",
                                                                    operator: "equal_to",
                                                                    value,
                                                                },
                                                            ],
                                                            extraParams: {
                                                                searchCrossTenant: !!search && true
                                                            }
                                                        }),
                                                    });
                                                    return items;
                                                },
                                            },
                                        },
                                    },
                                    rules: {
                                        equal_to: {},
                                    },
                                },
                            }),
                            status: {
                                type: "select",
                                attrs: {
                                    label: "Status",
                                    items: [
                                        { text: "Active", value: "active" },
                                        { text: "Inactive", value: "inactive" },
                                        { text: "Used", value: "used" },
                                    ],
                                },
                                rules: {
                                    equal_to: {},
                                },
                            },
                            startTime: {
                                type: "XDateTimePicker",
                                rules: {
                                    greater_than_or_equal_to: {
                                        attrs: {
                                            label: "Start Time (From)",
                                        },
                                    },
                                    less_than_or_equal_to: {
                                        attrs: {
                                            label: "Start Time (To)",
                                        },
                                    },
                                },
                            },
                            endTime: {
                                type: "XDateTimePicker",
                                rules: {
                                    greater_than_or_equal_to: {
                                        attrs: {
                                            label: "End Time (From)",
                                        },
                                    },
                                    less_than_or_equal_to: {
                                        attrs: {
                                            label: "End Time (To)",
                                        },
                                    },
                                },
                            },
                        },
                    },
                    displayFields: {
                        ...(userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
                            tenant: {
                                text: "Tenant",
                                options: {
                                    subProp: "tenant.name",
                                    label: true,
                                },
                            },
                        }),
                        code: {
                            text: "Code",
                            options: {
                                attrs: {
                                    class: "font-weight-bold",
                                },
                            },
                        },
                        serialNumber: {
                            text: "Serial Number",
                            options: {
                                transform: (data) => data || '-',
                            },
                        },
                        amount: {
                            text: "Amount",
                            options: {
                                transform: (data) => {
                                    return data ? new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: 'VND'
                                    }).format(data) : '-';
                                },
                            },
                        },
                        startTime: {
                            text: "Start Time",
                            options: {
                                transform: (data) => {
                                    return new Date(data).toLocaleString("en-GB");
                                },
                            },
                        },
                        endTime: {
                            text: "End Date",
                            options: {
                                transform: (data) => {
                                    return new Date(data).toLocaleString("en-GB");
                                },
                            },
                        },
                        expiryAfterActivation: {
                            text: "Usage Period (months)",
                            options: {
                                transform: (data) => {
                                    return data ? `${data} months` : '12 months';
                                },
                            },
                        },
                        status: {
                            text: "Status",
                            options: {
                                attrs(value) {
                                    return {
                                        color: value === 'inactive' ? "red" : "green",
                                    };
                                },
                            },
                        },
                        ...(userManager.checkRole(["systemAdmin", "admin"]) && {
                            usedByUser: {
                                text: "User",
                                options: {
                                    subProp: "usedByUser.email",
                                    label: true,
                                },
                            },
                        }),
                        createdTime: {
                            text: "Created Time",
                            options: {
                                transform: (data) => {
                                    return new Date(data).toLocaleString("en-GB");
                                },
                            },
                        },
                        action: {
                            text: "Actions",
                        },
                    },
                    topActionButtons: {
                        ...(userManager.checkRole(["systemAdmin", "admin"]) && {
                            history: {
                                content: {
                                    text: "History",
                                    icon: "mdi-history",
                                },
                                on: {
                                    xClick({ self }) {
                                        self.$router.push(`/app/vouchers_history`)
                                    },
                                },
                                ext: {
                                    sortPriority: -1
                                },
                            },
                            export: {
                                content: {
                                    text: "Export all",
                                    icon: "mdi-microsoft-excel",
                                },
                                on: {
                                    xClick({ self }) {
                                        const dataTable = self.context();
                                        coreApiClient.download(
                                            "vouchers",
                                            `@/export`,
                                            dataTable.getFindAllOptions()
                                        );
                                    },
                                },
                            },
                            insert: {},
                        }),
                    },
                    template: {
                        itemActionButtons: {
                            ...(userManager.checkRole(["systemAdmin", "admin"]) && {
                                edit: {
                                    target: {
                                        dialog: {
                                            ext: {
                                                subTitleMaker: "user.email",
                                            },
                                        },
                                    },
                                    ext: {
                                        condition: (_, item) => {
                                            return item.status !== 'used'
                                        }
                                    }
                                },
                                delete: {
                                    ext: {
                                        condition: (_, item) => {
                                            return item.status !== 'used'
                                        }
                                    }
                                },
                            }),
                        },
                    },
                },
                ext: {
                    dataProvider: {
                        async findAll(options) {
                            const { items, count } = await coreApiClient.call("vouchers", "findAll", options);
                            return [items, count];
                        },
                        async insert(item) {
                            if (item.startTime) {
                                item.startTime = moment(item.startTime).startOf('day').valueOf()
                            }
                            if (item.endTime) {
                                item.endTime = moment(item.endTime).endOf('day').valueOf()
                            }
                            return await coreApiClient.call("vouchers", "create", undefined, item);
                        },
                        async update(item) {
                            if (item.startTime) {
                                item.startTime = moment(item.startTime).startOf('day').valueOf()
                            }
                            if (item.endTime) {
                                item.endTime = moment(item.endTime).endOf('day').valueOf()
                            }
                            return await coreApiClient.call(
                                "vouchers",
                                "update",
                                {
                                    id: item._id,
                                },
                                {
                                    data: item,
                                }
                            );
                        },
                        async delete(item) {
                            return await coreApiClient.call("vouchers", "delete", {
                                id: item._id,
                            });
                        },
                    },
                    default: {
                        defaultInputs: {
                            ...(userManager.checkRole(["systemAdmin", "admin"]) && {
                                tenantId: {
                                    type: "XAutocomplete",
                                    attrs: {
                                        label: "Organization",
                                        required: true,
                                        "item-value": "_id",
                                        "item-text": "name",
                                        xOptions: {
                                            content: {
                                                async itemsSuggestor(search, value, limit) {
                                                    const { items } = await coreApiClient.call("tenants", "findAll", {
                                                        payload: JSON.stringify({
                                                            limit,
                                                            search,
                                                            orderBy: "name",
                                                            orderType: "asc",
                                                            filters: [
                                                                {
                                                                    key: "_id",
                                                                    operator: "equal_to",
                                                                    value,
                                                                },
                                                            ],
                                                        }),
                                                    });
                                                    return items;
                                                },
                                            },
                                        },
                                    },
                                    ext: {
                                        // Only show tenantId field in edit form if voucher is not active and not used
                                        condition: (formType, item) => {
                                            if (formType !== 'edit') { return true; }
                                            return item && item.status !== 'active' && item.status !== 'used';
                                        },
                                    },
                                },
                            }),
                            amount: {
                                type: "number",
                                attrs: {
                                    label: "Amount (VND)",
                                    required: true,
                                    rules: [
                                        (v) => v > 0 || "Amount must be greater than 0",
                                    ],
                                },
                            },
                            startTime: {
                                type: "XDateTimePicker",
                                attrs: {
                                    label: "Start Time",
                                    required: true,
                                },
                            },
                            endTime: {
                                type: "XDateTimePicker",
                                attrs: {
                                    label: "End Time",
                                    required: true,
                                },
                            },
                            status: {
                                type: "select",
                                attrs: {
                                    label: "Status",
                                    required: true,
                                    items: [
                                        { text: "Active", value: "active" },
                                        { text: "Inactive", value: "inactive" },
                                    ],
                                },
                            },
                            batchSize: {
                                type: "number",
                                attrs: {
                                    label: "Batch Size",
                                    required: true,
                                    rules: [
                                        (v) => v > 0 && v <= 1000 || "Batch size must be between 1 and 1000",
                                    ],
                                },
                                ext: {
                                    defaultValue: 1,
                                },
                            },
                            expiryAfterActivation: {
                                type: "number",
                                attrs: {
                                    label: "Usage period after activation (months)",
                                    required: true,
                                    hint: "Number of months the voucher can be used after activation",
                                    rules: [
                                        (v) => v > 0 || "Usage period must be greater than 0",
                                        (v) => v <= 60 || "Usage period cannot exceed 60 months",
                                    ],
                                },
                                ext: {
                                    defaultValue: 12,
                                },
                            },
                        },
                        insertForm: {
                            content: userManager.checkRole(["systemAdmin", "admin"]) ? {
                                fieldNames: [
                                    "tenantId",
                                    "amount",
                                    "startTime",
                                    "endTime",
                                    // "status",
                                    "batchSize",
                                    "expiryAfterActivation"
                                ],
                            } : {},
                        },
                        editForm: {
                            content: userManager.checkRole(["systemAdmin", "admin"]) ? {
                                fieldNames: [
                                    "tenantId",
                                    "amount",
                                    "startTime",
                                    "endTime",
                                    "status",
                                ],
                            } : {},
                        },
                        delete: {
                            confirmDisplayField: "code",
                        },
                    },
                },
            },
        };
    },
});

